import { frontendURL } from 'dashboard/helper/URLHelper';

import SettingsWrapper from 'dashboard/routes/dashboard/settings/SettingsWrapper.vue';
import FormsHome from './Index.vue';
import FormEdit from './FormEdit.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/crm/forms'),
      component: SettingsWrapper,
      // Not kept alive: the edit page loads its record on mount, so a cached instance would
      // show the first record opened when another one is picked.
      props: { keepAlive: false },
      children: [
        {
          path: '',
          name: 'forms_index',
          meta: { permissions: ['administrator'] },
          component: FormsHome,
        },
        {
          path: ':formId',
          name: 'forms_edit',
          meta: { permissions: ['administrator'] },
          component: FormEdit,
        },
      ],
    },
  ],
};
